import classNames from "classnames";
import type { WizardOptions } from "./types";

const ITEMS: { key: keyof WizardOptions; label: string; description: string }[] = [
  {
    key: "include3DThumbnail",
    label: "3D preview",
    description: "Rendered isometric view of the generated design.",
  },
  {
    key: "includeCarbonSummary",
    label: "CO₂ footprint",
    description: "Estimated embodied carbon for the generated design.",
  },
  {
    key: "includeZonesTable",
    label: "Zones table",
    description: "Per-zone metrics — area, units, efficiency.",
  },
];

export function StepOptions(props: {
  options: WizardOptions;
  onChange: (patch: Partial<WizardOptions>) => void;
}) {
  return (
    <div className="flex flex-col space-y-3 min-w-[420px]">
      {ITEMS.map((item) => (
        <label
          key={item.key}
          className="flex flex-row items-start space-x-3 cursor-pointer select-none"
        >
          <input
            type="checkbox"
            checked={props.options[item.key]}
            onChange={(evt) => props.onChange({ [item.key]: evt.target.checked })}
            className={classNames(
              "mt-1 rounded",
              props.options[item.key] && "text-primary-6",
              !props.options[item.key] && "text-white",
            )}
          />
          <div className="flex flex-col">
            <span className="text-body-1 text-neutral-8">{item.label}</span>
            <span className="text-body-2 text-neutral-6">{item.description}</span>
          </div>
        </label>
      ))}
    </div>
  );
}
